import { render, staticRenderFns } from "./CustomerServiceEmail.vue?vue&type=template&id=10ad3f91"
import script from "./CustomerServiceEmail.vue?vue&type=script&lang=js"
export * from "./CustomerServiceEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports